import { computed, ref } from 'vue'

import axios from 'axios'

const noncompliance_model_standard_items = ref([])

export default function useNoncomplianceModelStandardItem() {
  const listNoncomplianceModelStandardItems = async () => {
    axios
      .get('/api/standard_items/all')
      .then(function (response) {
        noncompliance_model_standard_items.value = response.data.data
      })
      .catch(function () {})
  }

  return {
    noncompliance_model_standard_items: computed(
      () => noncompliance_model_standard_items.value,
    ),
    listNoncomplianceModelStandardItems,
  }
}
